import React from 'react';

import css from '~/src/css/global.module.scss';

const Clock = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
        <path fill={css.colorSapphire} d="M20.29 21.71l1.41-1.41-4.7-4.7V9h-2v7.43l5.29 5.28z" />
        <path fill={css.colorSapphire} d="M17 5.05v2A9 9 0 0 1 16 25a9.11 9.11 0 0 1-1.81-.18l-.4 2A11.66 11.66 0 0 0 16 27a11 11 0 0 0 1-21.95z" />
        <path
            fill={css.colorElectricity}
            d="M14.19 24.82A9 9 0 0 1 7 16a8.94 8.94 0 0 1 3.59-7.19l-1.2-1.6A10.91 10.91 0 0 0 5 16a11 11 0 0 0 8.78 10.78l.4-2zM14.18 24.82z"
        />
        <path fill={css.colorPurple} d="M10.59 8.81A8.94 8.94 0 0 1 15 7.06v-2a10.88 10.88 0 0 0-5.61 2.15z" />
    </svg>
);

export default Clock;
